






























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {InputText, InputCheckbox} from 'simpli-web-sdk'
import PasswordConfirm from '@/components/PasswordConfirm.vue'
import {Responsavel} from '@/model/resource/Responsavel'

@Component({
  components: {PasswordConfirm, InputText, InputCheckbox},
})
export default class CheckboxWithPassword extends Vue {
  @Prop({type: Boolean, default: true}) flagValue!: boolean
  @Prop({type: String, default: null}) flagLabel!: string | null
  @Prop({type: String, default: null}) passwordValue!: string | null
  @Prop({type: String, required: true}) repeatPasswordLabel!: string | null
  @Prop({type: String, required: true}) passwordLabel!: string | null
  @Prop({type: String}) validation?: string

  isPasswordMatch: boolean = true

  onInput(val: boolean) {
    this.isPasswordMatch = val
    this.$emit('inputPasswordMatch', this.isPasswordMatch)
  }
  get confirmIsRequired() {
    // Se a senha é obrigatória
    if (this.validation?.includes('required')) return true
    else return !!this.password
  }

  get flag() {
    return this.flagValue
  }

  set flag(val: boolean) {
    this.$emit('input', val)
  }

  get password() {
    return this.passwordValue
  }

  set password(val: string | null) {
    this.$emit('updatePassword', val)
  }
}
